var items2 ='';
var crc322 = '';


function promptShareLink(items, crc32) {
	items2 = items;
	crc322 = crc32;
	
	$('#sendShareMail').show();
	
	// een demo user kan nu ook een article sharen maar dan is de &share verwijdert
	// anders komt er te staan &share=undefined
	var shareLink = 'https://ii.nl/?i=' + items; // remember that comments are only visible for logged in users
	
	$('#directShareLink').val(shareLink);
	$('#share_link').attr('href', shareLink);
	
	$('.twitter-share-button').attr('data-url', shareLink);
	$('#share_background').fadeIn(150);
	$('#share_container').fadeIn(150, function () {
		$('#share_container input')[0].setSelectionRange(0,999);
	});
}


function closeSharePopup() {
	$('#share_background').fadeOut(150);
	$('#share_container').fadeOut(150, function () {
		$('#directShareLink').val('');
		$('#toShareMail').val('');
		$('#toShareMail1').val('');
		$('#toShareMail2').val('');
		$('#toShareMail3').val('');
		$('#toShareMail4').val('');
		$('#toShareMail1').remove();
		$('#toShareMail2').remove();
		$('#toShareMail3').remove();
		$('#toShareMail4').remove();
		$('#shareError').hide();
		$('#shareSend').hide();
		$('#share_window').show();
		changenewmail(99);
	});
}


function sendShareMail() {
	
	var emails = [];
	
	emails.push($('#toShareMail').val());
	
	// TODO: dit kan handiger!
	if ($('#toShareMail1').length > 0) {
		emails.push($('#toShareMail1').val());
	}
	
	if ($('#toShareMail2').length > 0) {
		emails.push($('#toShareMail2').val());
	}
	
	if ($('#toShareMail3').length > 0) {
		emails.push($('#toShareMail3').val());
	}
	
	if ($('#toShareMail4').length > 0) {
		emails.push($('#toShareMail4').val());
	}
	
	// Nothing to send?
	if (emails.length == 0) {
		return;
	}
	
	$.ajax({
		    type: 'POST',
		     url: '/ajax/share',
		    data: { mode: 'mail', email: emails, crc: crc322, id: items2},
		dataType: 'JSON'
	}).then(function(data) {
		
		if (data['status'] == 'OK') {
			$('#shareSend').html('&#9733 Email succesvol verzonden &#9733');
			$('#shareSend').show();
			$('#share_window').hide();
		} else if (data['status'] == 'ERROR') {
			$('#shareError').html(data['result']['message']);
			$('#shareError').show();
		}
	});
}


$(document).ready(function() {

	function viewport() {
		var e = window, a = 'inner';
		//Cross browser? http://www.quirksmode.org/mobile/tableViewport.html
		if (!('innerWidth' in window )) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	}
	
	var left = viewport().width/2 - $('#share_container').outerWidth(true)/2;
	var top = viewport().height/2 - $('#share_container').outerHeight(true)/2;
	
	$('#share_container').css('left', left+'px');
	$('#share_container').css('top', top+'px');

	$('#share_background').hide();
	$('#share_container').hide();
	$('#shareError').hide();

	$(document).keyup(function (e) {
		if (e.keyCode == 27) { //esc
			if ($('#share_container').css('display') != 'none') {
				closeSharePopup();
				e.preventDefault();
			}
		}
	});
	
	$('#share_background').click(function () {
		closeSharePopup();
	});
	$('#share_close').click(function () {
		closeSharePopup();
	});

	$('#directShareLink').click(function () {
		this.setSelectionRange(0,999);
	});
	
	// use event delegation because click on the button was not working
	$("#share_container").on('click', '#sendShareMail', function () {
		sendShareMail();
	});
	
	$('#toShareMail').keyup(function (e) {
		if (e.keyCode  == 13) { //enter
			sendShareMail();
			e.preventDefault();
		}
	});
	
});
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
